import { createMemo, useContext } from "solid-js";
import { playerContext } from "../..";

const useCanSkip = () => {
	const { player } = useContext(playerContext);
	const canGoNext = createMemo(() => {
		const track = player.queue[player.track];
		if (player.loading || player.disabled || !track || track.type === "RADIO" || !player.queue[player.track + 1])
			return false;
		return true;
	});

	const canGoPrevious = createMemo(() => {
		const track = player.queue[player.track];
		if (player.loading || player.disabled || !track || track.type === "RADIO" || !player.queue[player.track - 1])
			return false;
		return true;
	});

	return { canGoNext, canGoPrevious };
};
export default useCanSkip;
